module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAAAAXNSR0IArs4c6QAAAJFJREFUSA1jZI5j9vz3n2EWAwODDBAjACPDYyYGhvS/i/5uBwlSSx0TVstANvxnkP3HwDATxAQBaqkDeoK+gImJkSENaOUTDGuhQQoTp7Y6mLnDj2akVuojNjWPptJ0WCoaTaWwkCBEj6ZSQiFEsvxoWUpykBHSMJpKCYUQyfKjqZTkICOkYTSVEgohkuXpnkoBs03fhfswNeYAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/density-jammed2x.png
// module id = MQ1w
// module chunks = 47